import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h1", null, "Organization Setup", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Next")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_el_form, {
      model: _ctx.form,
      rules: _ctx.rules,
      ref: "formRef",
      disabled: _ctx.fetchState === _ctx.FetchStates.FETCHING,
      "label-width": "150px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "Name",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              class: "half-width",
              modelValue: _ctx.form.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.name = $event)),
              onChange: _ctx.validateForm
            }, null, 8, ["modelValue", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "Address",
          prop: "address"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              class: "half-width",
              modelValue: _ctx.form.address,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.address = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "Address Line 2",
          prop: "address2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              class: "half-width",
              modelValue: _ctx.form.address2,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.address2 = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "City",
          prop: "city"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              class: "half-width",
              modelValue: _ctx.form.city,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.city = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "State",
          prop: "state"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              class: "half-width",
              modelValue: _ctx.form.state,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.state = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "Country",
          prop: "country"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              class: "half-width",
              modelValue: _ctx.form.country,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.country = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "Zip",
          prop: "zip"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              class: "half-width",
              modelValue: _ctx.form.zip,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.zip = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "Phone Number",
          prop: "main_phone"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              class: "half-width",
              modelValue: _ctx.form.main_phone,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.main_phone = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "US DOT #",
          prop: "us_dot_num"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              class: "half-width",
              modelValue: _ctx.form.us_dot_num,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.us_dot_num = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules", "disabled"]),
    _createVNode(_component_el_button, {
      onClick: _ctx.onNext,
      type: "primary",
      disabled: !_ctx.isValid
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["onClick", "disabled"])
  ], 64))
}